module.exports = __webpack_public_path__ + "static/media/don-4.0d5f9788.png";